<template>
  <div
    class="mb-1.5 mx-auto p-2 rounded bg-primary-shade-2 flex justify-center item-center cursor-pointer"
  >
    <Avatar class="my-auto ml-1" :src="avatar" />
    <div class="text-left text-sm mx-3.5">
      <p class="truncate" style="width: 9rem;">{{ name }}</p>
      <p class="font-bold">{{ formattedTime }}</p>
    </div>
    <FontAwesomeIcon class="my-auto mr-1" icon="calendar-alt" />
  </div>
</template>

<script>
import { timeFormat } from "@/mixins/timeFormat";

export default {
  name: "MenuAppointmentItem",
  components: {},
  props: {
    avatar: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    time: {
      type: Number,
      default: null
    }
  },
  computed: {
    formattedTime() {
      return timeFormat(this.time);
    }
  },
  data() {
    return {
      import_to_file: ""
    };
  },
  created() {}
};
</script>

<style></style>
